import { useState, useEffect } from "react";
import api from "../../api";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { toast } from "sonner";
 
const Login = () => {
  useEffect(() => {
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
}, []);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
 
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
 
  const callbackUrl = searchParams.get("returnUrl") || "/use-case-dashboard";
  const redirectPage = searchParams.get("redirect");
  const emailFromQuery = searchParams.get("email");
 
  useEffect(() => {
    if (emailFromQuery) {
      setEmail(emailFromQuery);
    }
  }, [emailFromQuery]);
 
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);
 
  const handleValueChange = (type, value) => {
    // if (type === "EMAIL") setEmail(value);
  if (type === "EMAIL") setEmail(value);


    if (type === "OTP") setOtp(value.replace(/\D/g, '').slice(0, 6));
    setMessage("");
    setErrors({});
  };
 
  const validateEmail = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email.";
    } else {
  const emailLower = email.toLowerCase();
  if (
    !emailLower.endsWith("@oges.co") &&
    !emailLower.endsWith("@ongc.co.in")
  ) {
    newErrors.email = "Email must be from ongc.co.in domain.";
  }
}

 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
  const validateOTP = () => {
    const newErrors = {};
 
    if (!otp) {
      newErrors.otp = "OTP is required.";
    } else if (otp.length !== 6) {
      newErrors.otp = "OTP must be 6 digits.";
    }
 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
  const handleSendOTP = async () => {
    if (!validateEmail()) return;
 
    setIsLoading(true);
    setMessage("Sending OTP...");
 
    try {
      // const res = await api.post("/auth/send-otp", { email });
      const res = await api.post("/auth/send-otp", { email: email.toLowerCase() });

     
      toast.success(res?.data?.message || "OTP sent successfully");
      setIsOTPSent(true);
      setMessage("OTP sent to your email");
      setCountdown(60); // 30 seconds countdown for resend
    } catch (err) {
      setMessage(err?.response?.data?.message || "Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };
 
const handleVerifyOTP = async () => {
  if (!validateOTP()) return;

  setIsLoading(true);
  setMessage("Verifying OTP...");

  try {
    const res = await api.post("/auth/verify-otp", { email: email.toLowerCase(), otp });

    toast.success(res?.data?.message || "Login successful");

    localStorage.setItem("token", res.data.token);
    // If userInfo is missing, create a fallback user object with name from email
    let userInfo = res.data.userInfo;
    if (!userInfo) {
      const emailStr = email.toLowerCase();
      const namePart = emailStr.split("@")[0];
      // Convert dots/underscores to spaces and capitalize each word
      const name = namePart
        .replace(/[._-]+/g, " ")
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      userInfo = { email: emailStr, name };
    }
    localStorage.setItem("currentUser", JSON.stringify(userInfo));

    // Redirect logic - prioritize returnUrl from query params
    if (callbackUrl && callbackUrl !== "/use-case-dashboard") {
      // If there's a returnUrl (like /udbhav-case), redirect there
      return navigate(callbackUrl, { replace: true });
    }

    if (redirectPage) {
      return navigate(`/${redirectPage}`, { replace: true });
    }


    // Check if user has ideas, then redirect accordingly
    try {
      const token = res.data.token;
      const ideasRes = await api.get("/ideas/my-ideas", {
        headers: { Authorization: `Bearer ${token}` },
        params: { email: email.toLowerCase() },
      });
      const oldIdeas = ideasRes.data?.oldIdeas || [];
      const currentIdeas = ideasRes.data?.currentIdeas || [];
      if ((oldIdeas && oldIdeas.length > 0) || (currentIdeas && currentIdeas.length > 0)) {
        // User has ideas, redirect to oldsubmit (or update as per your previous logic)
        return navigate(`/oldsubmit?email=${encodeURIComponent(email)}`, { replace: true });
      } else {
        // No ideas, go to udbhav-case
        return navigate(`/udbhav-case`, { replace: true });
      }
    } catch (ideaErr) {
      // If error in fetching ideas (e.g., user not found), fallback to udbhav-case
      return navigate(`/udbhav-case`, { replace: true });
    }

  } catch (err) {
    setMessage(err?.response?.data?.message || "Invalid OTP");
  } finally {
    setIsLoading(false);
  }
};
 
  const handleResendOTP = () => {
    setOtp("");
    setMessage("");
    handleSendOTP();
  };
 
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        className="elementor-widget-container"
        style={{
          width: "40%",
          minWidth: "320px",
          background: "#111",
          padding: "35px",
          borderRadius: "12px",
          boxShadow: "0 0 20px rgba(255,255,255,0.08)",
          color: "white",
        }}
      >
        <h4
          className="text-gradient"
          style={{
            textAlign: "center",
            fontSize: 30,
            color: "#62d6e5",
            marginBottom: "20px"
          }}
        >
          Login with OTP
        </h4>
             <h2
          className="text-gradient"
          style={{
            textAlign: "center",
            fontSize: 14,
            color: "#d3dfe1",
            marginBottom: "20px"
          }}
        >
    Use the same email ID that you used while submitting ideas in Udbhav 1.0
        </h2>
 
        {/* Email */}
        <div style={{ width: "100%", marginBottom: "15px" }}>
          <label style={{ marginBottom: 6, display: "block", fontSize: 14 }}>
            Email*
          </label>
          <input
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "6px",
              border: "1px solid #333",
              background: emailFromQuery ? "#333" : "#222",
              color: "white",
              opacity: emailFromQuery ? 0.6 : 1,
              cursor: emailFromQuery ? "not-allowed" : "text",
            }}
            type="email"
            value={email}
            disabled={Boolean(emailFromQuery) || isOTPSent}
            onChange={(e) => handleValueChange("EMAIL", e.target.value)}
            placeholder="Enter your ONGC email"
          />
          {errors.email && (
            <p style={{ color: "red", marginTop: 5, marginBottom: 0, fontSize: "12px" }}>{errors.email}</p>
          )}
        </div>
 
        {/* OTP Input */}
        {isOTPSent && (
          <div style={{ width: "100%", marginBottom: "20px" }}>
            <label style={{ marginBottom: 6, display: "block", fontSize: 14 }}>
              OTP*
            </label>
            <input
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #333",
                background: "#222",
                color: "white",
                fontSize: "18px",
                letterSpacing: "8px",
                textAlign: "center"
              }}
              type="text"
              maxLength={6}
              value={otp}
              onChange={(e) => handleValueChange("OTP", e.target.value)}
              placeholder="Enter 6-digit OTP"
            />
            {errors.otp && (
              <p style={{ color: "red", marginTop: 5, marginBottom: 0, fontSize: "12px" }}>{errors.otp}</p>
            )}
          </div>
        )}
 
        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            marginTop: "20px"
          }}
        >
          {!isOTPSent ? (
            <button
              style={{
                background: "#62d6e5",
                color: "#000",
                padding: "0px 35px",
                height: 45,
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                fontWeight: 600,
                opacity: isLoading ? 0.6 : 1
              }}
              type="button"
              onClick={handleSendOTP}
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send OTP'}
            </button>
          ) : (
            <>
              <button
                style={{
                  background: "#62d6e5",
                  color: "#000",
                  padding: "0px 25px",
                  height: 45,
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                  opacity: isLoading ? 0.6 : 1
                }}
                type="button"
                onClick={handleVerifyOTP}
                disabled={isLoading}
              >
                {isLoading ? 'Verifying...' : 'Verify OTP'}
              </button>
              <button
                style={{
                  background: "transparent",
                  color: "#62d6e5",
                  padding: "0px 20px",
                  height: 45,
                  borderRadius: "8px",
                  border: "1px solid #62d6e5",
                  cursor: countdown > 0 ? "not-allowed" : "pointer",
                  fontWeight: 600,
                  opacity: countdown > 0 ? 0.5 : 1
                }}
                type="button"
                onClick={handleResendOTP}
                disabled={countdown > 0}
              >
                {countdown > 0 ? `Resend (${countdown}s)` : 'Resend'}
              </button>
            </>
          )}
        </div>
 
        {/* Message */}
        <div>
          <p style={{
            color: message.includes('successfully') ? 'green' : 'red',
            marginTop: "15px",
            textAlign: "center",
            fontSize: "14px"
          }}>
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};
 
export default Login;
 
 